module.exports = __webpack_public_path__ + "img/9_Zusammen sind wir stark Elias Emil Leo Linda Maximilian Jeeli.5466ff85.jpg";